import React from "react";
import './SendSMS.scss';
import LogoSloganImage from "../../../resources/images/ShipitLogoWithSlogan.png";
import GenericAutosuggest from "../../Components/GenericAutosuggest/GenericAutosuggest";
import axios from "axios";
import Paper from "@material-ui/core/Paper";
import TagFacesIcon from '@material-ui/icons/TagFaces';
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SendSMSConfirmationDialog from "./SendSMSConfirmationDialog/SendSMSConfirmationDialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import Direction from "../../Utils/Direction/Direction";


export default class SendSMS extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            textMessage: '',
            users: [],
            isConfirmationDialogOpen: false
        };
    }

    onNameSelected(user) {
        if (user && !this.state.users.some(u => u.id === user.id)) {
            this.setState(state => {
                return {users: [...state.users, user]}
            })
        }
    }

    handleDeleteUser = data => () => {
        this.setState(state => {
            const users = [...state.users];
            const userToDelete = users.indexOf(data);
            users.splice(userToDelete, 1);
            return {users};
        });
    };

    static async fetchPredictions(name) {
        const {data: predictions} = await axios.get('/api/v2a/autocompleteUserByName', {
            params: {
                name: name
            }
        });

        return predictions.map(prediction => {
            return {
                "label": prediction.name,
                "id": prediction.id
            }
        });
    }

    handleSMSTextChange(event) {
        this.setState({
            textMessage: event.target.value
        });
    }

    handleSendButton() {
        this.setState({
            isConfirmationDialogOpen: true
        });
    }

    closeConfirmationDialog() {
        this.setState({
            isConfirmationDialogOpen: false
        });
    }

    async handleSendConfirmed() {
        if (this.clearSuccessTimeout)
            clearTimeout(this.clearSuccessTimeout);

        this.closeConfirmationDialog();

        this.setState({
            isSendLoading: true,
            isSendSuccess: undefined
        });

        const {data: result} = await axios.post('/api/v2a/sendSms', {
            users: this.state.users.map(u => u.id),
            message: this.state.textMessage
        });

        this.setState({
            isSendLoading: false,
            isSendSuccess: result.success
        });

        this.clearSuccessTimeout = setTimeout((() => {
            this.setState({
                isSendSuccess: undefined
            });

            this.clearSuccessTimeout = undefined;
        }).bind(this), 2000);
    }

    render() {
        return (
            <Direction direction="rtl">
                <div className="page">
                    <div className="logo">
                        <img src={LogoSloganImage}/>
                    </div>

                    <div className="content">
                        <div className="page-title-text">
                            שליחת SMS ללקוחות
                        </div>
                        <div className="send-sms-content">
                            <GenericAutosuggest label={"שם"}
                                                placeholder={"הקלד שם"}
                                                fetchPredictions={SendSMS.fetchPredictions}
                                                value={this.state.name}
                                                onSelect={this.onNameSelected.bind(this)}
                                                className="name-autosuggest"
                            />
                            <Paper className="users-chip-list">
                                {this.state.users.map(data => {
                                    let icon = null;

                                    if (data.label === 'React') {
                                        icon = <TagFacesIcon/>;
                                    }

                                    return (
                                        <Chip
                                            key={data.id}
                                            icon={icon}
                                            label={data.label}
                                            onDelete={this.handleDeleteUser(data)}
                                            className="user-chip"
                                        />
                                    );
                                })}
                            </Paper>

                            <TextField
                                label="תוכן הודעת הטקסט"
                                multiline
                                rows="4"
                                margin="normal"
                                variant="outlined"
                                value={this.state.textMessage}
                                onChange={this.handleSMSTextChange.bind(this)}
                            />
                            <div className="send-button-container">
                                <Button
                                    disabled={this.state.isSendLoading}
                                    className={`send-button ${(this.state.isSendSuccess === true ? 'send-button-success' : this.state.isSendSuccess === false ? 'send-button-failure' : '')}`}
                                    variant="contained" color="primary"
                                    onClick={this.handleSendButton.bind(this)}>
                                    שלח
                                </Button>
                                {this.state.isSendLoading &&
                                <CircularProgress size={24} className="send-button-loader"/>}
                            </div>
                        </div>
                    </div>

                    <SendSMSConfirmationDialog open={this.state.isConfirmationDialogOpen}
                                               users={this.state.users}
                                               message={this.state.textMessage}
                                               onCancel={this.closeConfirmationDialog.bind(this)}
                                               onSend={this.handleSendConfirmed.bind(this)}/>
                </div>
            </Direction>
        );
    }
}